import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import Button from '../../UniformComponents/Button'
import Modal from '../../UniformComponents/Modal'
import Typography from '../../UniformComponents/Typography'
import Checkbox from '../form/Checkbox'

const KpiModal = (props) => {
    const { certificationStore } = props
    const {
        kpiModalFunc, toggleShowKpiModal, setIncludedKpis, kpiModalSubmission,
        includedKpis, oss, os, nps,
    } = certificationStore
    const showOSS = oss && oss > 40
    const hasNextStep = kpiModalFunc === 'linkedin'

    return (
        <Modal show={!!kpiModalFunc} onClose={() => toggleShowKpiModal(undefined)}>
            <div className="uc-modal__header">
                <Typography type="h2">{i18n.t('certificationKpiModal.title')}</Typography>
            </div>
            <div style={{ marginInline: '32px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <Typography type="p" style={{ textAlign: 'center', marginBlock: '16px' }}>
                    {i18n.t('certificationKpiModal.subTitle')}
                </Typography>
                <div style={{ marginLeft: undefined }}>
                    {os
                        ? (
                            <Checkbox
                                label={i18n.t('certification.certificate.showSatisfactionLabel')}
                                name="OS"
                                checked={includedKpis.get('OS')}
                                onBlur={({ name, value }) => setIncludedKpis(name, value)}
                            />
                        ) : null}
                    {nps
                        ? (
                            <Checkbox
                                label={i18n.t('certification.certificate.showNPS')}
                                name="NPS"
                                checked={includedKpis.get('NPS')}
                                onBlur={({ name, value }) => setIncludedKpis(name, value)}
                            />
                        ) : null }
                    {/* {showOSS
                        ? (
                            <Checkbox
                                label={i18n.t('certification.certificate.showScore')}
                                name="OSS"
                                checked={includedKpis.get('OSS')}
                                onBlur={({ name, value }) => setIncludedKpis(name, value)}
                            />
                        )
                        : null} */}
                </div>
                <div className="uc-modal__button-panel" style={{ justifyContent: 'space-between' }}>
                    <Button
                        cssClass="regular"
                        variant="tertiary"
                        label={i18n.t('cancel')}
                        onClick={() => toggleShowKpiModal(undefined)}
                    />
                    <Button
                        cssClass="regular"
                        variant="primary"
                        label={i18n.t(hasNextStep ? 'continue' : 'certificationKpiModal.download_cert')}
                        style={{ width: hasNextStep ? undefined : '170px' }}
                        onClick={kpiModalSubmission}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default observer(KpiModal)
